var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 2C9.34558 2 8.52819 2.66465 8.33497 3.59209L7.25082 8.79605C7.12144 9.41703 7.59548 10 8.2298 10H11.25V21.25H7.99999C7.58578 21.25 7.24999 21.5858 7.24999 22C7.24999 22.4142 7.58578 22.75 7.99999 22.75H16C16.4142 22.75 16.75 22.4142 16.75 22C16.75 21.5858 16.4142 21.25 16 21.25H12.75V10H15.7702C16.4045 10 16.8785 9.41703 16.7492 8.79605L15.665 3.59209C15.4718 2.66465 14.6544 2 13.707 2H10.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightStand);
export default __webpack_public_path__ + "static/media/light-stand.c28b7935cc378f56a5298f9e4ea13cc3.svg";
export { ForwardRef as ReactComponent };